export enum PriorityEnum{
    high='high',
    medium='medium',
    low='low',
} 